import React, { Component } from "react";
import "./style/Come.scss";

class Come extends Component {
  render() {
    return (
      <div className="ComeContainer">
        <div className="Come_TextBox">
          <div className="Come_Title">오시는 길</div>
          <div className="Come_Box">
            <div className="Come_One">주소</div>
            <div className="Come_Two">
            서울특별시 중구 다산로32, 428,429호(신당동, 남산타운 상가2동)
            </div>
          </div>
          <div className="Come_Box">
            <div className="Come_One">전화</div>
            <div className="Come_Two">1599-9964</div>
          </div>
          <div className="Come_Box">
            <div className="Come_One">팩스</div>
            <div className="Come_Two">02-517-1493</div>
          </div>
          <div className="Come_Box">
            <div className="Come_One">이메일</div>
            <div className="Come_Two">ejh0329@naver.com</div>
          </div>
        </div>
        <div className="Hanbit_Map" style={{ paddingTop: "30px" }}>
          <iframe
            title="HanbitLocation"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3163.1437447693047!2d127.011097!3d37.551677!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca30e8d26d725%3A0x94655807a91363a7!2z64Ko7IKw7YOA7Jq0MuyDgeqwgA!5e0!3m2!1sko!2s!4v1761293409745!5m2!1sko!2s"
            width="100%"
            height="100%"
            frameborder="0"
            allowfullscreen=""
          ></iframe>
        </div>
      </div>
    );
  }
}

export default Come;
